import { OcCsvExportQueryModelInput } from 'src/graphql/types';

export enum ExportSource {
  People = 'people',
  WorkerEngagements = 'worker_engagements',
  Timesheets = 'timesheets',
  Expenses = 'expenses',
  Invoices = 'invoices',
  Suppliers = 'suppliers',
  WorkRequests = 'work_requests',
  WorkPostings = 'work_postings',
  JobApplications = 'job_applications',
  Contracts = 'contracts',
  CustomObjects = 'custom_objects',
  CostCenters = 'cost_centers',
  RateCards = 'rate_cards',
  BusinessSites = 'business_sites',
  JobProfiles = 'job_profiles',
  JobFamilies = 'job_families',
  JobFamilyGroups = 'job_family_groups',
  Organizations = 'organizations'
}

export enum LegacyExportSource {
  users = 'users'
}

export type ExportEntityUnionType = LegacyExportEntity | ExportEntity;

export type ExportMode = 'batch-csv' | 'batch-excel';

export type ExportLegacyMode = 'syncCsv';

export interface LegacyExportEntity {
  source: LegacyExportSource;
  mode: ExportLegacyMode;
  query: { users?: InputMaybe<OcCsvExportQueryModelInput['users']> };
  reportName: string | undefined;
}

export type ExportEntity = ExportType & {
  mode: ExportMode;
  reportName: string | undefined;
};

export type ExportType =
  | { source: ExportSource.People; query: { people?: InputMaybe<OcCsvExportQueryModelInput['people']> } }
  | { source: ExportSource.Contracts; query: { contracts?: InputMaybe<OcCsvExportQueryModelInput['contracts']> } }
  | { source: ExportSource.Timesheets; query: { timesheets?: InputMaybe<OcCsvExportQueryModelInput['timesheets']> } }
  | { source: ExportSource.Expenses; query: { expenses?: InputMaybe<OcCsvExportQueryModelInput['expenses']> } }
  | { source: ExportSource.Invoices; query: { invoices?: InputMaybe<OcCsvExportQueryModelInput['invoices']> } }
  | {
      source: ExportSource.CustomObjects;
      query: { customObjects?: InputMaybe<OcCsvExportQueryModelInput['customObjects']> };
    }
  | { source: ExportSource.Suppliers; query: { suppliers?: InputMaybe<OcCsvExportQueryModelInput['suppliers']> } }
  | {
      source: ExportSource.JobApplications;
      query: { jobApplications?: InputMaybe<OcCsvExportQueryModelInput['jobApplications']> };
    }
  | {
      source: ExportSource.WorkPostings;
      query: { workPostings?: InputMaybe<OcCsvExportQueryModelInput['workPostings']> };
    }
  | {
      source: ExportSource.WorkRequests;
      query: { workRequests?: InputMaybe<OcCsvExportQueryModelInput['workRequests']> };
    }
  | {
      source: ExportSource.WorkerEngagements;
      query: { workerEngagements?: InputMaybe<OcCsvExportQueryModelInput['workerEngagements']> };
    }
  | {
      source: ExportSource.CostCenters;
      query: { costCenters?: InputMaybe<OcCsvExportQueryModelInput['costCenters']> };
    }
  | {
      source: ExportSource.RateCards;
      query: { rateCards?: InputMaybe<OcCsvExportQueryModelInput['rateCards']> };
    }
  | {
      source: ExportSource.BusinessSites;
      query: { locations?: InputMaybe<OcCsvExportQueryModelInput['locations']> };
    }
  | {
      source: ExportSource.JobProfiles;
      query: { jobProfiles?: InputMaybe<OcCsvExportQueryModelInput['jobProfiles']> };
    }
  | {
      source: ExportSource.JobFamilies;
      query: { jobFamilies?: InputMaybe<OcCsvExportQueryModelInput['jobFamilies']> };
    }
  | {
      source: ExportSource.JobFamilyGroups;
      query: { jobFamilyGroups?: InputMaybe<OcCsvExportQueryModelInput['jobFamilyGroups']> };
    }
  | {
      source: ExportSource.Organizations;
      query: { organizations?: InputMaybe<OcCsvExportQueryModelInput['organizations']> };
    };
